import "../../.csscode/PopUpModal.css";

const EmployeeSelectionModal = ({
  showModal,
  employees,
  selectedEmployees,
  handleEmployeeSelection,
  closeModal,
}) => {
  if (!showModal) return null;

  return (
    <div className="employee-selection-modal">
      <div className="employee-selection-modal-content">
        <h3>Select Employees</h3>

        <table className="employee-selection-modal-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Select</th>
            </tr>
          </thead>
          <tbody>
            {employees.length > 0 ? (
              employees.map((emp) => (
                <tr key={emp.value}>
                  <td>{emp.label}</td>
                  <td>
                    <input
                      type="checkbox"
                      className="employee-selection-modal-checkbox"
                      value={emp.value}
                      checked={selectedEmployees[emp.value] || false}
                      onChange={handleEmployeeSelection}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="no-employees-message">
                  No employees available for this department
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <button
          className="employee-selection-modal-close-btn"
          onClick={closeModal}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default EmployeeSelectionModal;
